import React, { useState, useEffect, useRef } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { ToastContainer } from "react-toastify";
import { BiPhone, BiUser } from "react-icons/bi";
import { motion, AnimatePresence } from "framer-motion";
import { FaSearch } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import CustomerForm from "./CustomerForm";
import { BiDialpad } from "react-icons/bi";
import { AiOutlinePlus } from "react-icons/ai";
import DialerPopup from "./DialerPopup";
import ExcelHandler from "./ExcelHandler";
import { useContext } from "react";
import { ConfigContext } from "../../context/ConfigContext";
import { toast } from "react-toastify";



// import { ToastContainer, toast } from "react-toastify";
const CRM = ({ user }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [loadingState, setLoadingState] = useState({});
  const [showCallModal, setShowCallModal] = useState(false);
  const [callStatus, setCallStatus] = useState('calling');
  const [currentContact, setCurrentContact] = useState(null);
  const [callTime, setCallTime] = useState(0);
  const [staticData, setstaticData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDialerOpen, setIsDialerOpen] = useState(false);

  const importFileInputRef = useRef(null); // Separate ref for CRM import

  const { config } = useContext(ConfigContext);

  // Call stats state
  const [callStats, setCallStats] = useState({
    callLimit: null,
    callsUsed: 0,
    remainingCalls: null,
    hasUnlimitedCalls: true
  });

  // Fetch call statistics
  const fetchCallStats = async () => {
    const userId = user?.id || user?._id;
    if (!userId) return;

    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_API}/api/users/call-stats/${userId}`);
      setCallStats(response.data);
    } catch (error) {
      console.error('Error fetching call stats:', error);
    }
  };

  const fetchContacts = async () => {
    setIsLoading(true);
    const userId = user?.id || user?._id;
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_API}/api/contacts?userId=${userId}&role=${user.role}`);
      setstaticData(response.data);
      console.log("response.dataresponse.data", response.data);

    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
    setIsLoading(false);
  };

  const { handleImportExcel, handleExportExcel } = ExcelHandler({ fetchContacts, user });
  // Fetch contacts from database
  useEffect(() => {
    fetchContacts();
    fetchCallStats(); // Fetch call stats on mount
  }, [user]);

  const handleCall = async (contact) => {
    // Check call limit before initiating call
    if (!callStats.hasUnlimitedCalls && callStats.remainingCalls <= 0) {
      toast.error('Call limit reached! You have no remaining calls.');
      return;
    }

    setCurrentContact(contact);
    setShowCallModal(true);
    setCallStatus('calling');
    setLoadingState(prev => ({ ...prev, [contact.id]: true }));
    if (!user) {
      console.error("No user logged in");
      return;
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/api/create-call`, {
        to: contact.MobileNumber,
        name: contact.name,
        first_message: config.firstMessage,
        prompt: config.callPrompt,
        userId: user.id || user._id,
        voiceId: config.voiceId,
        language: config.language,
        modelId: config.modelId,
        agentId: config.agentId
      }, {
        headers: { 'Content-Type': 'application/json' },
      });

      const { callId, callSid } = response.data;
      localStorage.setItem('currentCallSid', callSid);
      localStorage.setItem('currentCallId', callId);
      setCallStatus('connected');

      // Update call stats after successful call
      await fetchCallStats();

      // Show appropriate toast based on remaining calls
      const newRemaining = callStats.remainingCalls - 1;
      if (!callStats.hasUnlimitedCalls) {
        if (newRemaining === 0) {
          toast.warning('This was your last call! Contact admin to increase your limit.');
        } else if (newRemaining <= 5) {
          toast.warning(`Only ${newRemaining} calls remaining!`);
        } else {
          toast.success(`Call initiated successfully! Remaining calls: ${newRemaining}`);
        }
      } else {
        toast.success('Call initiated successfully!');
      }

      navigate(`/call/${encodeURIComponent(contact.name)}/${encodeURIComponent(contact.MobileNumber)}`);

      const startTime = Date.now();
      setInterval(() => {
        setCallTime(Math.floor((Date.now() - startTime) / 1000));
      }, 1000);

    } catch (error) {
      console.error('Call failed:', error);

      // Handle call limit error from backend
      if (error.response && error.response.status === 403) {
        toast.error(error.response.data.message || 'Call limit reached!');
        await fetchCallStats(); // Refresh stats
      } else {
        toast.error('Call failed. Please try again.');
      }

      setCallStatus('error');
    } finally {
      setLoadingState(prev => ({ ...prev, [contact.id]: false }));
    }
  };
  // console.log("DialerPopup Rendered, handleCall crm:", handleCall);
  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  // Data filtering and pagination
  const filteredData = Array.isArray(staticData) ? staticData.filter(row =>
    row.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    row.email?.toLowerCase().includes(searchTerm.toLowerCase())
  ) : [];
  const indexOfLastItem = currentPage * itemsPerPage;
  const currentData = filteredData && filteredData.slice(indexOfLastItem - itemsPerPage, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <motion.div
      className="bg-gray-50 items-center p-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="max-w-9xl ">
        {/* Header */}
        <div className="bg-white  p-1 mb-2 shadow-lg rounded-xl">
          <h1 className="text-2xl font-bold text-gray-800">CallCentri CRM</h1>
        </div>

        {/* Search */}
        <div className="relative mb-2">
          <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
          <input
            type="text"
            placeholder="Search by name or email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-white border border-gray-300 rounded-lg pl-12 pr-8 py-4 shadow-md"
          />
          {searchTerm && (
            <AiOutlineClose
              onClick={() => setSearchTerm("")}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer"
            />
          )}
        </div>

        {/* Loading Spinner */}
        <ToastContainer />
        <div className="flex items-center gap-4 mb-6">
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-blue-700 transition"
          >
            <AiOutlinePlus className="w-5 h-5" /> Add Customer
          </button>

          <button
            onClick={() => setIsDialerOpen(true)}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-green-700 transition"
          >
            <BiDialpad className="w-5 h-5" /> Call Customer
          </button>
          <button
            onClick={() => handleExportExcel(staticData)}
            className="flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-purple-700 transition"
          >
            Export to Excel
          </button>

          <div>
            <input
              type="file"
              ref={importFileInputRef}
              accept=".xlsx, .xls"
              onChange={(e) => handleImportExcel(e, user)} // Pass user to handler
              className="hidden"
              id="excel-import-crm"
            />
            <label
              htmlFor="excel-import-crm"
              className="cursor-pointer flex items-center gap-2 bg-teal-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-teal-700 transition"
            >
              Import Data from Excel
            </label>
          </div>
        </div>
        {isLoading && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 animate-pulse">
            <AiOutlineLoading3Quarters
              className="animate-spin text-white"
              size={48}
            />
          </div>
        )}
        {/* Contacts Table */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-blue-600 text-white">
              <tr>
                {["ID", "Name", "Phone", "Location", "Email", "Actions"].map((header) => (
                  <th key={header} className="px-4 py-3 text-md font-semibold text-center">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentData && currentData.length > 0 ? (
                currentData.map((row, index) => {
                  const autoIncrementId = (currentPage - 1) * itemsPerPage + index + 1;
                  return (
                    <tr key={autoIncrementId} className="hover:bg-gray-100 transition-all">
                      <td className="px-4 py-3 text-md text-center truncate">{autoIncrementId}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.name}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.MobileNumber}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.location}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.email}</td>
                      <td className="px-4 py-3 text-md text-center">
                        <button
                          onClick={() => handleCall(row)}
                          className="text-blue-600 hover:text-blue-800 disabled:opacity-50"
                          disabled={loadingState[row.id || row.MobileNumber]}
                        >
                          {loadingState[row.id || row.MobileNumber] ? (
                            <AiOutlineLoading3Quarters className="animate-spin h-6 w-6" />
                          ) : (
                            <BiPhone className="h-6 w-6" />
                          )}
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-8 text-gray-500">
                    No contacts data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="flex justify-center mt-8 space-x-2">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-200 rounded-md disabled:opacity-50 hover:bg-gray-300"
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, idx) => (
            <button
              key={idx}
              onClick={() => paginate(idx + 1)}
              className={`px-4 py-2 rounded-md ${currentPage === idx + 1 ? 'bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300'
                }`}
            >
              {idx + 1}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-200 rounded-md disabled:opacity-50 hover:bg-gray-300"
          >
            Next
          </button>
        </div>
        {/* Call Modal */}
        <AnimatePresence>
          {showCallModal && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4"
            >
              <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                className="bg-white rounded-xl p-8 max-w-md w-full"
              >
                <div className="text-center space-y-4">
                  {/* Profile Icon */}
                  <div className="w-20 h-20 bg-gray-100 rounded-full mx-auto flex items-center justify-center">
                    <BiUser className="w-12 h-12 text-gray-500" />
                  </div>

                  {/* Contact Info */}
                  <h3 className="text-xl font-semibold">{currentContact?.name}</h3>
                  <p className="text-gray-600">{currentContact?.MobileNumber}</p>

                  {/* Call Status */}
                  <div className="text-lg font-medium text-gray-700">
                    {callStatus === 'calling' && (
                      <div className="flex items-center justify-center space-x-2">
                        <span>Calling...</span>
                        <div className="flex space-x-1">
                          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" />
                          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-100" />
                          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-200" />
                        </div>
                      </div>
                    )}
                    {callStatus === 'connected' && formatTime(callTime)}
                    {callStatus === 'error' && 'Call Failed'}
                  </div>

                  {/* Action Buttons */}
                  <button
                    onClick={() => {
                      setShowCallModal(false);
                      window.close();
                    }}
                    className="w-full bg-red-600 text-white py-3 rounded-full hover:bg-red-700 transition-colors"
                  >
                    {callStatus === 'error' ? 'Close' : 'End Call'}
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
        <DialerPopup isOpen={isDialerOpen} onClose={() => setIsDialerOpen(false)} user={user} ></DialerPopup>
        <CustomerForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} fetchContacts={fetchContacts} handleCall={handleCall} user={user} />
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </motion.div>
  );
};

export default CRM;
